import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MealPlanModel } from '@models/meal-plan/meal-plan.model';
import { MealPlanService } from '@services/meal-plan.service';
import { AppRoutes } from '@helpers/app-routes';
import { FormatPricePipe } from '@pipes/format-price.pipe';

@Component({
  selector: 'app-choose-meal-plan-page',
  imports: [TranslateModule, FormatPricePipe],
  templateUrl: './choose-meal-plan-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'block h-full',
  },
})
export class ChooseMealPlanPageComponent {
  private readonly router = inject(Router);
  private readonly mealPlanService = inject(MealPlanService);

  readonly mealPlans = input.required<MealPlanModel[]>();

  selectMealPlan(mealPlan: MealPlanModel): void {
    this.mealPlanService.setMealPlan(mealPlan);
    void this.router.navigate([AppRoutes.order]);
  }
}
